export interface IModuleTriggerWidgetComponentProps {}

/**
 * Il widget non è visibile in compilazione
 */
export function ModuleTriggerWidgetComponent(
  props: IModuleTriggerWidgetComponentProps,
) {
  return null;
}
